export const hasNextPage = (pagination: {
    perPage: number;
    currentOffset: number;
    totalCount: number;
}): boolean => {
    return (
        pagination.currentOffset + pagination.perPage < pagination.totalCount
    );
};

export const paginate = <T>(
    items: T[],
    currentPage: number,
    perPage: number
): T[] => {
    const start = (currentPage - 1) * perPage;
    const end = start + perPage;

    return items.slice(start, end);
};
